import React, { useState } from 'react';

export default function PasswordField({
  label,
  name,
  value,
  onChange,
  placeholder = 'Enter password',
  error = '',
  required = true,
  autoComplete,
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="mb-4">
      {label && (
        <label className="block text-body-sm font-medium text-on-background mb-2">
          {label}
          {required && <span className="text-error">*</span>}
        </label>
      )}

      <div className="relative">
        <input
          type={showPassword ? 'text' : 'password'}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          autoComplete={autoComplete}
          className={`w-full px-4 py-2 border rounded-lg bg-background text-on-background placeholder-on-background/40 transition-colors ${
            error
              ? 'border-error focus:border-error focus:outline-none'
              : 'border-outline focus:border-primary focus:outline-none'
          }`}
        />

        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-on-background/60 hover:text-on-background transition-colors p-1"
          title={showPassword ? 'Hide password' : 'Show password'}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          {showPassword ? '🙈' : '👁️'}
        </button>
      </div>

      {error && (
        <p className="text-body-xs text-error mt-1">{error}</p>
      )}
    </div>
  );
}
